module.exports = __webpack_public_path__ + "img/erp-feature7.73374400.png";